import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericPost } from '@/_shared/types';
import { GenericApiError } from '@/_shared/types/apiError';
import { getCurrentOrganization } from '@/core/state';
import { API_ORGANIZATIONS_ORGANIZATIONID_QUIZZES_COMPLETIONS_PATH_KEY } from '@/swagger/constants/quiz-keys';
import { API_POST_QUIZ_START, KEY_POST_QUIZ_START } from '../constats';
import { MOCK_RESPONSE_POST_QUIZ_START } from '../mocks';

type RequestPostQuizStart = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_QUIZZES_COMPLETIONS_PATH_KEY
>['request']['body'];

type ResponsePostQuizStart = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_QUIZZES_COMPLETIONS_PATH_KEY
>['response']['body'];

type CallParamsPostQuizStart = RequestPostQuizStart & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponsePostQuizStart = ResponsePostQuizStart;

type CallErrorPostQuizStart = GenericApiError;

type CallSelectorsPostQuizStart = unknown;

export const postQuizStartCall = createGeneralCall<
  CallParamsPostQuizStart,
  CallResponsePostQuizStart,
  CallErrorPostQuizStart,
  CallSelectorsPostQuizStart
>({
  id: KEY_POST_QUIZ_START,
  method: 'post',
  url: () => state => {
    const org = getCurrentOrganization(state);
    return API_POST_QUIZ_START(org);
  },
  paramsSelector:
    ({ payload }) =>
    () =>
      payload,
  successMock: IS_MOCK_ENABLED({ avoidMockOnDemoMode: true })
    ? MOCK_RESPONSE_POST_QUIZ_START
    : undefined,
});
